"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldInputType = void 0;
var tslib_1 = require("tslib");
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
exports.FormFieldInputType = prop_types_1.default.shape({
    value: prop_types_1.default.any,
    name: prop_types_1.default.string.isRequired,
    onChange: prop_types_1.default.func.isRequired,
    produce: prop_types_1.default.func.isRequired,
});
//# sourceMappingURL=FormFieldInputType.js.map